import { render, staticRenderFns } from "./Scrollmenu.vue?vue&type=template&id=4d36c265&"
import script from "./Scrollmenu.vue?vue&type=script&lang=js&"
export * from "./Scrollmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports